import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=6a2c3572&scoped=true&"
import script from "./footerPage.vue?vue&type=script&lang=js&"
export * from "./footerPage.vue?vue&type=script&lang=js&"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=6a2c3572&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c3572",
  null
  
)

export default component.exports